import { STEP_COLOR_STATUSES } from 'constants/status.constants';

export const STEP_STATUS_TOOLTIPS = {
  [STEP_COLOR_STATUSES.DEFAULT]: 'Incomplete',
  [STEP_COLOR_STATUSES.ORANGE]: 'Nearing due date',
  [STEP_COLOR_STATUSES.RED]: 'Almost at due date',
  [STEP_COLOR_STATUSES.PENDING]: 'Pending verification',
  [STEP_COLOR_STATUSES.COMPLETED]: 'Completed',
  [STEP_COLOR_STATUSES.DISABLED]: 'Disabled',
  [STEP_COLOR_STATUSES.PARTIALLY_COMPLETED]: 'Partially completed',
  [STEP_COLOR_STATUSES.ARCHIVED]: 'Archived',
};

export const CERT_STATUS_TOOLTIPS = {
  [STEP_COLOR_STATUSES.DEFAULT]: 'Incomplete',
  [STEP_COLOR_STATUSES.ORANGE]: 'Due date for some steps is coming',
  [STEP_COLOR_STATUSES.RED]: 'Action required. Due date for some steps is coming very soon',
  [STEP_COLOR_STATUSES.PENDING]: 'Pending verification',
  [STEP_COLOR_STATUSES.COMPLETED]: 'Completed',
  [STEP_COLOR_STATUSES.DISABLED]: 'Disabled',
  [STEP_COLOR_STATUSES.ARCHIVED]: 'Archived',
  [STEP_COLOR_STATUSES.PAUSED]: 'Paused',
};

export const WORKFLOW_PHASE_STATUS_TOOLTIPS = {
  [STEP_COLOR_STATUSES.DEFAULT]: 'Incomplete',
  [STEP_COLOR_STATUSES.ORANGE]: 'Due date for some steps is coming',
  [STEP_COLOR_STATUSES.RED]: 'Action required. Due date for some steps is coming very soon',
  [STEP_COLOR_STATUSES.PENDING]: 'Pending verification',
  [STEP_COLOR_STATUSES.COMPLETED]: 'Completed',
  [STEP_COLOR_STATUSES.DISABLED]: 'Disabled',
  [STEP_COLOR_STATUSES.FAILED]: 'Failed',
};
